module.exports = __webpack_public_path__ + "static/media/bg-balloon-talk.b0c4e0c5.svg";